// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__b7qSh","label":"CategoryService_label__2-28X","location":"CategoryService_location__2PMWU"};